<template>
  <div class="pt-9 px-md-5">
    <div
      class="container d-flex justify-content-center"
      v-if="userRole == 'PROFISSIONAL'"
    >
      <b-card class="w-100">
        <b-card-header class="border-0">
          <h3 class="mb-0 text-center">
            As suas indicações já foram computadas com sucesso. Obrigado!
          </h3>
        </b-card-header>
      </b-card>
    </div>
    <b-card no-body v-if="userRole !== 'PROFISSIONAL'">
      <b-card-header class="border-0">
        <b-row align-v="center" slot="header">
          <b-col cols="8">
            <h3 class="mb-0">Peças inscritas</h3>
          </b-col>
          <b-col cols="4" class="text-right">
            <button href="#!" class="btn btn-primary" @click="novaPeca">
              Inscrever Peça
            </button>
          </b-col>
        </b-row>
      </b-card-header>

      <el-table
        class="table-responsive table"
        header-row-class-name="thead-light"
        :data="pecas"
        empty-text="Não há dados para mostrar. Para cadastrar a primeira peça, clique em 'Inscrever Peça'."
      >
        <el-table-column
          label="Nome da Peça"
          v-if="
            userRole == 'PUBLICITARIO' ||
            userRole == 'FORNECEDOR' ||
            userRole == 'PROFISSIONAL_INDEPENDENTE'
          "
          prop="pecaTitulo"
          min-width="140px"
        >
        </el-table-column>

        <el-table-column
          label="Categoria"
          v-if="userRole == 'PUBLICITARIO'"
          prop="idCategoriaPecaPublicitaria"
          min-width="140px"
        >
          <template v-slot="{ row }">
            <div class="d-flex align-items-center">
              {{
                categorias.find((i) => i.id == row.idCategoriaPecaPublicitaria)
                  ? categorias.find(
                      (i) => i.id == row.idCategoriaPecaPublicitaria
                    ).nome
                  : ""
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Categoria"
          v-if="userRole == 'FORNECEDOR'"
          prop="idCategoriaPecaFornecedor"
          min-width="140px"
        >
          <template v-slot="{ row }">
            <div class="d-flex align-items-center">
              {{
                categorias.find((i) => i.id == row.idCategoriaPecaFornecedor)
                  ? categorias.find(
                      (i) => i.id == row.idCategoriaPecaFornecedor
                    ).nome
                  : ""
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Categoria"
          v-if="userRole == 'ESTUDANTE'"
          prop="idCategoriaPecaEstudante"
          min-width="140px"
        >
          <template v-slot="{ row }">
            <div class="d-flex align-items-center">
              {{
                categorias.find((i) => i.id == row.idCategoriaPecaEstudante)
                  ? categorias.find((i) => i.id == row.idCategoriaPecaEstudante)
                      .nome
                  : ""
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Categoria"
          v-if="userRole == 'PROFISSIONAL_INDEPENDENTE'"
          prop="idCategoriaPecaProfissionalIndependente"
          min-width="140px"
        >
          <template v-slot="{ row }">
            <div class="d-flex align-items-center">
              {{
                categorias.find(
                  (i) => i.id == row.idCategoriaPecaProfissionalIndependente
                )
                  ? categorias.find(
                      (i) => i.id == row.idCategoriaPecaProfissionalIndependente
                    ).nome
                  : ""
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Cliente"
          v-if="
            userRole == 'PUBLICITARIO' ||
            userRole == 'FORNECEDOR' ||
            userRole == 'PROFISSIONAL_INDEPENDENTE'
          "
          prop="nomeCliente"
          min-width="140px"
        >
        </el-table-column>

        <el-table-column
          label="Responsável"
          v-if="
            userRole == 'PUBLICITARIO' ||
            userRole == 'FORNECEDOR' ||
            userRole == 'PROFISSIONAL_INDEPENDENTE'
          "
          prop="nomeResponsavel"
          min-width="140px"
        >
        </el-table-column>

        <el-table-column
          label="Grupo"
          v-if="userRole == 'ESTUDANTE'"
          prop="grupo"
          min-width="140px"
        >
        </el-table-column>

        <el-table-column
          label="Nomes"
          v-if="userRole == 'ESTUDANTE'"
          prop="detalhesEstudante"
          min-width="140px"
        >
          <template v-slot="{ row }">
            <div class="d-flex align-items-center">
              {{ row.detalhesEstudante.map((e) => e.nome).join(", ") }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Coordenador"
          v-if="userRole == 'ESTUDANTE'"
          prop="nomeCoordenador"
          min-width="140px"
        >
        </el-table-column>

        <el-table-column
          label="Data de Cadastro"
          prop="dataHoraInscricao"
          min-width="140px"
        >
          <template v-slot="{ row }">
            <div class="d-flex align-items-center">
              {{ format(new Date(row.dataHoraInscricao), "dd/MM/yyyy") }}
            </div>
          </template>
        </el-table-column>
        <!--           
          <el-table-column label="Detalhes" prop="id" min-width="80px">
              <template v-slot="{row}">
                  <div class="d-flex align-items-center">
                    <router-link :to="'/publicitarios/' + row.id" class="btn btn-sm btn-primary text-nowrap">
                      <i class="ni ni-zoom-split-in"></i>
                    </router-link>
                  </div>
              </template>
          </el-table-column> -->
      </el-table>

      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="10"
          :total="10"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import api from "@/services/api";
import format from "date-fns/format";

export default {
  name: "home-user",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      format,
      userRole: "",
      pecas: [],
      categorias: [],
      currentPage: 1,
    };
  },
  methods: {
    novaPeca() {
      switch (this.userRole) {
        case "PUBLICITARIO":
          this.$router.push({ name: "cadastroPecaPublicitaria" });
          break;
        case "ESTUDANTE":
          this.$router.push({ name: "cadastroPecaEstudante" });
          break;
        case "FORNECEDOR":
          this.$router.push({ name: "cadastroPecaFornecedor" });
          break;
        case "PROFISSIONAL_INDEPENDENTE":
          this.$router.push({ name: "cadastroPecaProfissionalIndependente" });
          break;
      }
    },
  },
  async mounted() {
    try {
      const strUser = localStorage.getItem("user@mf");
      if (strUser) {
        const user = JSON.parse(strUser);
        this.userRole = user.role;

        switch (this.userRole) {
          case "PUBLICITARIO": {
            const respPecaPub = await api.get("/peca-publicitaria/me?size=10000");
            const respCategoriaPub = await api.get(
              "/categoria-peca-publicitaria"
            );
            this.pecas = respPecaPub.data.data || [];
            this.categorias = respCategoriaPub.data.data;
            break;
          }
          case "ESTUDANTE": {
            const respPecaEst = await api.get("/peca-estudante/me?size=10000");
            const respCategoriaEst = await api.get("/categoria-peca-estudante");
            this.pecas = respPecaEst.data.data || [];
            this.categorias = respCategoriaEst.data.data;
            break;
          }
          case "FORNECEDOR": {
            const respPecaFor = await api.get("/peca-fornecedor?size=10000");
            const respCategoriaFor = await api.get(
              "/categoria-peca-fornecedor"
            );
            this.pecas =
              respPecaFor.data.data?.filter(
                (p) => p.idFornecedor == user.details.id
              ) || [];
            this.categorias = respCategoriaFor.data.data;
            break;
          }
          case "PROFISSIONAL_INDEPENDENTE": {
            const respPecaProfissionalIndependente = await api.get(
              "/peca-profissional-independente?size=10000"
            );
            const respCategoriaProfissionalIndependente = await api.get(
              "/categoria-peca-profissional-independente"
            );
            this.pecas =
              respPecaProfissionalIndependente.data.data?.filter(
                (p) => p.idProfissionalIndependente == user.details.id
              ) || [];
            this.categorias = respCategoriaProfissionalIndependente.data.data;
            break;
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  },
};
</script>
